import { NetworkDirectoryCard } from 'src/assets/styles/components/network';
import { jobPostingsFromRecord } from 'src/containers/comunidad-network/form/networkFormUtils';

const getInitials = (name = '') => {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return 'EM';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

const ComunidadNetworkCard = ({ network, selected = false, showCategory = false, onSelect }) => {
  const { id, businessName, businessPhone, serviceOffered, category, logo, jobPostings } =
    network;
  const service = serviceOffered || '';
  const preview = service.length > 90 ? `${service.slice(0, 90)}...` : service;
  const withCategory = showCategory && Boolean(category);
  const hasJobs = jobPostingsFromRecord(jobPostings).some(
    (posting) => posting.title.trim() || posting.description.trim()
  );
  const cardClass = [selected && 'is-selected', hasJobs && 'has-jobs'].filter(Boolean).join(' ');

  return (
    <NetworkDirectoryCard
      type="button"
      className={cardClass || undefined}
      aria-pressed={selected}
      onClick={() => onSelect(id)}
    >
      <div
        className={`directory-card__avatar${logo ? ' has-photo' : ''}`}
        aria-hidden="true"
        style={logo ? { backgroundImage: `url(${logo})` } : undefined}
      >
        {logo ? '' : getInitials(businessName)}
      </div>
      <div className="directory-card__content">
        {withCategory && <p className="directory-card__category">{category}</p>}
        <h2 className="directory-card__name">{businessName}</h2>
        {preview && <p className="directory-card__service">{preview}</p>}
        {businessPhone && <p className="directory-card__meta">{businessPhone}</p>}
      </div>
      {hasJobs && <span className="directory-card__jobs" role="img" aria-label="Tiene vacantes" />}
    </NetworkDirectoryCard>
  );
};

export default ComunidadNetworkCard;
